import { useAuth } from "../App";
import { isSuperAdmin } from "./useSuperAdmin";

export function useCanViewFinancials() {
  const { user } = useAuth();
  return user?.revenue_access === true || user?.role?.toLowerCase() === "admin" || isSuperAdmin(user?.email);
}
